import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateDiagnosticGuide } from 'src/app/utils/interfaces/new/create-diagnostic-guide.interface';
import { DiagnosticGuide } from 'src/app/utils/interfaces/new/diagnostic-guide.interface';
import { Diagnostic } from 'src/app/utils/interfaces/new/diagnostic.interface';
import { HistoriqueCritere } from 'src/app/utils/interfaces/new/historique-critere.interface';
import { MaquetteGuide } from 'src/app/utils/interfaces/new/maquette-guide.interface';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class DiagnosticGuideService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };
  private uri = environment.basePath + "/consultation/diagnostic-guide";

  constructor(
    private http: HttpClient,
    private _snack: SnackbarService
  ) { }

  public async create(diagsGuide: CreateDiagnosticGuide[]): Promise<MaquetteGuide> {
    try {
      const res = await this.http.post(this.uri, diagsGuide, this.httpOptions).toPromise();
      const result = res.body as MaquetteGuide;
      return result;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async update(diagGuides: Array<DiagnosticGuide>) {
    try {
      if (diagGuides.length === 0) {
        return;
      }

      const res = await this.http.put(this.uri + "/update-guides", diagGuides, this.httpOptions).toPromise();
      return;
    } catch (error) {
      throw error;
      // this._snack.openSnackBar(error.error.message);
    }
  }

  public async findOne(diagGuideId: string): Promise<DiagnosticGuide> {
    try {
      const res = await this.http.get(this.uri + "/" + diagGuideId, this.httpOptions).toPromise();
      const diagGuide = res.body as DiagnosticGuide;
      return diagGuide;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async delete(diagGuideId: Array<string>) {
    try {
      if (diagGuideId.length === 0) {
        return;
      }

      const options = {...this.httpOptions};

      let params = new HttpParams();
      diagGuideId.forEach(query => {
        params = params.append('diagnosticGuideIdsQuery', query);
      });

      (options as any).params = params;

      await this.http.delete(this.uri + "/delete-guides", options).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findByDiagnosticId(diagId: string): Promise<MaquetteGuide[]> {
    try {
      const res = await this.http.get(this.uri + "/diagnostic/" + diagId, this.httpOptions).toPromise();
      const diagsGuide = res.body as MaquetteGuide[];
      return diagsGuide;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async deleteAll(diagId: string) {
    try {
      const res = await this.http.delete(this.uri + "/diagnostic/" + diagId, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findDistinctCritereByPatientId(patientId: string): Promise<Map<string, HistoriqueCritere[]>> {
    try {
      const res = await this.http.get(this.uri + "/critere/" + patientId, this.httpOptions).toPromise();
      const diagsGuide = res.body as any;

      const mapRtd: Map<string, HistoriqueCritere[]> = new Map<string, HistoriqueCritere[]>();
      Object.keys(diagsGuide).forEach(key => {
        mapRtd.set(key, diagsGuide[key]);
      });

      return mapRtd;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async getDefault(patientId: string) {
    try {
      const res = await this.http.get(this.uri + "/default/" + patientId, this.httpOptions).toPromise();
      const diag = res.body as Diagnostic;
      return diag;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async setDefault(diagId: string, patientId: string) {
    try {
      const res = await this.http.put(this.uri + "/default/" + diagId + "/" + patientId, undefined, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async deleteDefault(diagId: string, patientId: string) {
    try {
      const res = await this.http.delete(this.uri + "/default/" + diagId + "/" + patientId, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async getHistoriqueCritere( patientId: string, critereId: string, options: { mode?: 'last' | 'all' | 'period'; limit?: 10 | 20; dateDebut?: string; dateFin?: string; } = {} ): Promise<HistoriqueCritere[]> {
    try {
      const params: string[] = [];
      if (options.mode) params.push('mode=' + options.mode);
      if (options.limit) params.push('limit=' + options.limit);
      if (options.dateDebut) params.push('dateDebut=' + options.dateDebut);
      if (options.dateFin) params.push('dateFin=' + options.dateFin);

      const query = params.length ? '?' + params.join('&') : '';
      const res = await this.http.get(this.uri + '/historique/' + patientId + '/' + critereId + query, this.httpOptions).toPromise();

      return res.body as HistoriqueCritere[];
    } catch (error) {
      this._snack.openSnackBar(error.error?.message || 'Erreur lors de la récupération de l’historique');
      throw error;
    }
  }

}
